import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { restriction_returndata } from 'src/types/restriction_returndata'; 
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';



@Component({
  selector: 'app-restriction',
  templateUrl: './restriction.component.html',
  styleUrls: ['./restriction.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RestrictionComponent implements OnInit {
  ListRestrictions: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledRestriction: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;

  httpResponse: any;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 
      //this.isRowSelectable = this.isRowSelectable.bind(this);
    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("RESTRICTIONS", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(RestrictionID)
  {
    this.http.delete(bmxurl + "Restriction/" + this.VenueID + "/" + RestrictionID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Restriction successfully disabled'});
        this.router.navigateByUrl("/restriction");

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Restriction'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "RestrictionList/" + this.VenueID + "/" + "/" + showdisabled).subscribe(response => {
      this.ListRestrictions = (response as restriction_returndata);
    }, error => {
    });
  }

  editData(EditData)
  {
    let RestrictionID = EditData;
    this.router.navigateByUrl("/restrictionedit/" + RestrictionID);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "Restriction/" + this.VenueID + "/" + element.ageGroupID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.loadgrid(false);
      } 
    }, error => {
    
    })
    });
    
  }

  
  }